export const pros = [
  "Direct payment",
  "Clear project scope",
  "Central communication",
  "Schedule management"
];
